import { render } from "./TaskTypeUpdate.vue?vue&type=template&id=4f709d18&scoped=true"
import script from "./TaskTypeUpdate.vue?vue&type=script&lang=js"
export * from "./TaskTypeUpdate.vue?vue&type=script&lang=js"

import "./TaskTypeUpdate.vue?vue&type=style&index=0&id=4f709d18&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f709d18"]])

export default __exports__